import { API_CONFIG } from '@/utils/constants';

export function sendLinkTap(handle: string, linkId: string): void {
  if (!handle || !linkId) return;

  const url = `${API_CONFIG.BASE_URL}/profiles/${encodeURIComponent(
    handle,
  )}/tap?link=${encodeURIComponent(linkId)}`;

  try {
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      if (navigator.sendBeacon(url)) return;
    }
    void fetch(url, { method: 'POST', keepalive: true }).catch(() => undefined);
  } catch {
    /* fire-and-forget: never surface */
  }
}
